import PropTypes from "prop-types";

/**
 * PropTypes for Login view
 *
 * @property {function} [onSubmit] - Login form submission handler
 * @property {boolean} [loading] - Loading/submitting state
 * @property {string} [error] - Error message to display
 */
export const loginPropTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

/**
 * PropTypes for Register view
 *
 * @property {function} [onSubmit] - Registration form submission handler
 * @property {boolean} [loading] - Loading/submitting state
 * @property {string} [error] - Error message to display
 */
export const registerPropTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

/**
 * PropTypes for TwoFactorAuth view
 *
 * @property {function} [onSubmit] - 2FA code submission handler
 * @property {function} [onResend] - Resend code handler
 * @property {boolean} [loading] - Loading/submitting state
 * @property {string} [error] - Error message to display
 */
export const twoFactorAuthPropTypes = {
  onSubmit: PropTypes.func,
  onResend: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

/**
 * PropTypes for RecoverPassword view
 *
 * @property {function} [onSubmit] - Password recovery submission handler
 * @property {boolean} [loading] - Loading/submitting state
 * @property {string} [error] - Error message to display
 * @property {boolean} [success] - Success state
 */
export const recoverPasswordPropTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.string,
  success: PropTypes.bool,
};

/**
 * PropTypes for ResetPassword view
 *
 * @property {function} [onSubmit] - Password reset submission handler
 * @property {boolean} [loading] - Loading/submitting state
 * @property {string} [error] - Error message to display
 * @property {string} [token] - Reset token from URL
 */
export const resetPasswordPropTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.string,
  token: PropTypes.string,
};
